import { StarGroup } from '@/assets/icons/star-group'

interface TranscriptReadingFeedbackProps {
  variant: 'success' | 'error' | 'withoutEquivalence'
}

const config = {
  success: {
    status:
      'Pronto! Nossa IA já fez uma leitura prévia das disciplinas equivalentes',
    label: 'Como funciona:',
    description:
      'Nesta etapa você pode verificar as disciplinas que a IA selecionou e confirmar se estiver de acordo. Se entender que existem outras disciplinas que podem ser adicionadas, você mesmo pode fazer isso!'
  },
  error: {
    status: 'Infelizmente nossa IA não conseguiu ler seu documento 🙁',
    label: 'O que fazer agora?',
    description: (
      <>
        Agora você pode adicionar manualmente as disciplinas que entende que
        pode dispensar. É só clicar no botão{' '}
        <strong>“Adicionar Disciplina +”</strong>
      </>
    )
  },
  withoutEquivalence: {
    status: 'O Izzy não identificou nenhuma equivalência entre os currículos',
    label: 'O que fazer agora?',
    description: (
      <>
        Agora você pode adicionar manualmente as disciplinas que entende que
        pode dispensar. É só clicar no botão{' '}
        <strong>“Adicionar Disciplina +”</strong>
      </>
    )
  }
}

export const TranscriptReadingFeedback = ({
  variant
}: TranscriptReadingFeedbackProps) => {
  const text = config[variant]
  return (
    <div className="flex flex-col gap-3 mb-5 max-w-9/12">
      <div className="text-xs w-fit bg-[var(--brand-blue-1)]/20 flex text-muted-foreground items-center font-bold gap-1 border border-[var(--brand-blue-2)] rounded-lg px-4 py-2">
        <StarGroup />
        {text.status}
      </div>

      <p className="font-bold text-[var(--brand-blue-1)]">{text.label}</p>
      <p>{text.description}</p>
    </div>
  )
}
